import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import CapitalIncreaseModalScriptureView from './CapitalIncreaseModalScriptureView';
import CapitalIncreaseModalMovementsView from './CapitalIncreaseModalMovementsView';
import { useCapitalIncreaseModal } from '../context/CapitalIncreaseModalContext';

const CapitalIncreaseModalBody: FC = () => {
  const { data } = useCapitalIncreaseModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? (
          <CapitalIncreaseModalScriptureView />
        ) : (
          <CapitalIncreaseModalMovementsView />
        )}
      </div>
    </Modal.Body>
  );
};

export default CapitalIncreaseModalBody;
